/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div class="page-wrapper">
    <section class="hero-wrapper">
      <header class="hero-nav">
        <div class="nav-left">
          <img src="../assets/images/ania-logo.png" alt="Logo AniaTek" class="logo">
        </div>

        <nav class="nav-center">
          <a href="#seccion-inicio">Inicio</a>
          <a href="#seccion-preguntas">Preguntas</a>
          <a href="#seccion-contactanos">Contáctanos</a>
        </nav>

        <div class="nav-right">
          <router-link to="/login" class="login-btn">Acceder</router-link>
        </div>
      </header>

      <img class="hero-video" src="../assets/images/PanelesCuatro.jpg" alt="">

      <div class="hero-content-clean">
        <h1 class="hero-title">
          Cotiza proyectos de energía solar fotovoltaica en minutos
        </h1>

        <p class="hero-subtitle">
          Software profesional para instaladores fotovoltaicos en México
        </p>

        <button class="select-plan-btn integrated" @click="openRegisterModal">Registrarme y probar</button>

        <p class="hero-proof">
          +350 cotizaciones generadas por instaladores reales
        </p>
      </div>

      <div class="mobile-menu" id="mobileMenu" aria-hidden="true">
        <a href="#">Home</a>
        <a href="#">Services</a>
        <a href="#">Pages</a>
        <a href="#">Project</a>
        <a href="#">Blog</a>
      </div>

    </section>
  </div>

  <a href="https://wa.me/526677978683?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20ANIATEK"
    target="_blank" class="whatsapp-float">
    <i class="fab fa-whatsapp"></i>
  </a>

  <section class="system-overview-section">
    <div class="system-overview-container">
      <div class="section-header">
        <h1>Cotiza tu proyecto fotovoltaico</h1>
        <h2>Un software que te ayuda a optimizar tu gestión de ventas de una forma más ágil</h2>
      </div>
      <div class="system-content-wrapper">
        <div class="system-image-box" id="system-image-slider">
          <div class="slider-item active">
            <img src="../assets/images/CapLogin.png" alt="Diseño de Sistema Solar Interactivo">
            <p class="module-description">¡Bienvenido a ANIATEK! Somos tu socio estratégico para la transición
              energética.</p>
          </div>
          <div class="slider-item">
            <img src="../assets/images/CapBienvenida.png" alt="Diseño de Sistema Solar Interactivo">
            <p class="module-description">Este sistema está diseñado para que tu trabajo sea más eficiente desde la
              primera interacción con la plataforma</p>
          </div>
          <div class="slider-item">
            <img src="../assets/images/CapCotizador.png" alt="Simulación de Ahorros y Producción">
            <p class="module-description">El Cotizador Solar Inteligente te permite diseñar tu sistema fotovoltaico en
              minutos.</p>
          </div>
          <div class="slider-item">
            <img src="../assets/images/CapClientes.png" alt="Simulación de Ahorros y Producción">
            <p class="module-description">Gestiona a todos tus clientes de manera centralizada con una vista completa
              del historial de cotizaciones.</p>
          </div>
          <div class="slider-item">
            <img src="../assets/images/CapProveedores.png" alt="Mapa de radiación solar">
            <p class="module-description">Accede a un catálogo de proveedores recomendado con precios actualizados (de
              referencia)*.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="solar-benefits-section">
    <div class="solar-benefits-container" id="seccion-destino">
      <div class="section-header">
        <h1>¿Por qué elegir ANIATEK?</h1>
        <h2>Tu software auxiliar para el desarrollo de proyectos de energía solar fotovoltaica</h2>
      </div>
      <div class="cards-wrapper">
        <div class="benefit-card">
          <div class="benefit-icon">
            <i class="fas fa-clock"></i>
          </div>
          <h3>Cotizaciones en Minutos</h3>
          <p>Nuestro algoritmo inteligente genera cálculos fotovoltaicos y cotizaciones en cuestión de segundos.
          </p>
        </div>
        <div class="benefit-card">
          <div class="benefit-icon">
            <i class="fas fa-user"></i>
          </div>
          <h3>Agenda electrónica</h3>
          <p>Es una plataforma que almacena toda la información de cada cliente o prospecto de tu empresa.</p>
        </div>
        <div class="benefit-card">
          <div class="benefit-icon">
            <i class="fas fa-chart-line"></i>
          </div>
          <h3>Optimiza tu cartera de clientes</h3>
          <p>Presenta cotizaciones profesionales y comparativas de ahorro visuales para el cliente.</p>
        </div>

        <div class="system-info-card full-span">
          <div class="info-content">
            <div class="integrated-price-box">
              <div class="price-header">
                <h3>Membresía</h3>
              </div>
              <p class="price-value">$999<span>MXN/mes</span></p>
              <ul class="features-list-integrated">
                <li>* Módulos de cotización ilimitados</li>
                <li>* Seguimiento a instalaciones</li>
                <li>* Acceso a proveedores</li>
                <li>* Agenda de clientes</li>
                <li>* Sin publicidad</li>
                <li>* Soporte</li>
              </ul>
              <button class="select-plan-btn integrated" @click="openRegisterModal">Registrarme y pagar</button>
            </div>
            <div class="info-text-right">
              <h3>Tu socio estratégico en energía solar</h3>
              <div class="stars">Más de 350 cotizaciones exitosas.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faqs-section">
    <div class="faqs-container" id="seccion-preguntas">
      <div class="section-header">
        <h1>Preguntas Frecuentes</h1>
        <h2>Todo lo que necesitas saber antes de empezar</h2>
      </div>

      <div class="faqs-wrapper">
        <div class="faq-left-card">
          <div class="faq-icon-large">
            <i class="fas fa-question-circle"></i>
          </div>
        </div>

        <div class="faq-list-right">
          <div class="faq-item">
            <button class="faq-question">
              ¿La membresía incluye actualizaciones del sistema?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>Sí. Todas las actualizaciones de módulos, mejoras y nuevas funciones están incluidas sin costo
                adicional mientras tu membresía esté activa.</p>
            </div>
          </div>
          <div class="faq-item">
            <button class="faq-question">
              ¿Puedo cancelar la membresía en cualquier momento?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>Claro. Puedes cancelar cuando lo necesites, sin penalizaciones ni contratos forzosos.</p>
            </div>
          </div>
          <div class="faq-item">
            <button class="faq-question">
              ¿El sistema funciona en cualquier estado de México?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>Sí, el cotizador utiliza datos de irradiación reales para todo el país, incluyendo zonas específicas
                con variaciones climatológicas.</p>
            </div>
          </div>
          <div class="faq-item">
            <button class="faq-question">
              ¿Qué tan precisas son las cotizaciones?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>Nuestro motor de cálculo integra tablas oficiales, modelos de degradación, rendimiento por marca y
                climatología histórica para generar estimaciones técnicas orientativas, basadas en escenarios reales,
                que apoyan la toma de decisiones comerciales.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="cta-wrapper">
    <div class="cta-container">
      <div class="cta-left">
        <h2 class="cta-title">
          ¿Buscas un experto en <br>
          <span style="color: #29b9f6;">energía solar?</span>
        </h2>
        <p class="cta-desc">
          Descubre cómo las últimas innovaciones en energía fotovoltaica pueden impulsar tu proyecto y reducir costos.
        </p>
        <a href="tel:+526677978683" class="cta-phone-box" title="Llámanos por teléfono">
          <i class="fas fa-phone-alt"></i>
          <div class="cta-phone-text">
            <p>Habla con nosotros</p>
            <strong>+52 (667) 797 8683</strong>
          </div>
        </a>
      </div>
      <div class="cta-right">
        <img src="../assets/images/Instalador.jpg" alt="Solar Panels" />
      </div>
    </div>
  </section>

  <footer class="footer">
    <div class="footer-top">
      <div class="footer-col footer-info">
        <div class="footer-logo">
          <img src="../assets/images/ania-logo.png" alt="ANIATEK">
        </div>
        <p class="footer-desc">
          En ANIATEK creemos en el poder de la energía renovable para construir un futuro verdaderamente sostenible, con
          pasión por la energía limpia y un compromiso real con nuestros clientes, ofrecemos soluciones que destacan por
          su calidad y eficiencia.
        </p>
        <div class="footer-social">
          <a href="URL_DE_TU_FACEBOOK" target="_blank" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
          <a href="URL_DE_TU_LINKEDIN" target="_blank" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
          <a href="URL_DE_TU_INSTAGRAM" target="_blank" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
          <a href="URL_DE_TU_YOUTUBE" target="_blank" aria-label="YouTube"><i class="fab fa-youtube"></i></a>
        </div>
      </div>

      <div class="footer-col contact-box" id="seccion-contactanos">
        <h3>Contáctanos</h3>
        <p>
          <i class="fas fa-phone-alt"></i>
          <a href="tel:+526677978683" aria-label="Llamar al número de contacto">+52 (667) 797 8683</a>
        </p>
        <p>
          <i class="fas fa-envelope"></i>
          <a href="mailto:energyaniasolar@gmail.com" aria-label="Enviar correo">energyaniasolar@gmail.com</a>
        </p>
        <p>
          <i class="fas fa-map-marker-alt"></i>
          Culiacán, Sinaloa, México
        </p>
      </div>
    </div>
    <div class="footer-bottom">
      <p>ANIATEK ©, Todos los derechos reservados.</p>
      <div class="footer-links">
        <a href="#">Políticas de privacidad</a>
        <a href="#">Términos y condiciones</a>
      </div>
      <div class="powered-by">
        <p>Desarrollado por:</p>
        <a href="https://www.connectandlaunch.com.mx" aria-label="Ir a la landing page de ANIATEK">
          <img src="../assets/images/LogoConnect.png" alt="ANIATEK Logo" style="height: 35px;">
        </a>
      </div>
    </div>
  </footer>

  <div v-if="showRegisterModal" class="modal-overlay" @click.self="closeRegisterModal">
    <div class="modal-content">
      <button class="close-modal-btn" @click="closeRegisterModal">&times;</button>

      <div class="modal-header">
        <img src="../assets/images/ania-logo.png" alt="ANIATEK Logo" class="modal-logo">
        <h2>Regístrate para continuar</h2>
      </div>

      <Registrar :isLanding="true" />
    </div>
  </div>
</template>

<script>
import Registrar from '../components/auth/Registrar.vue';

export default {
  name: 'LandingPage',
  components: {
    Registrar
  },
  data() {
    return {
      slideInterval: null,
      showRegisterModal: false
    };
  },
  mounted() {
    this.initializeSlider();
    this.initializeFaqs();
    this.initializeHamburgerMenu();
  },
  beforeUnmount() {
    this.stopAutoSlide();
  },
  methods: {
    openRegisterModal() {
      this.showRegisterModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeRegisterModal() {
      this.showRegisterModal = false;
      document.body.style.overflow = 'auto';
    },

    showSlide(items, index) {
      items.forEach((item, i) => {
        item.style.display = i === index ? 'block' : 'none';
      });
    },

    stopAutoSlide() {
      if (this.slideInterval) {
        clearInterval(this.slideInterval);
        this.slideInterval = null;
      }
    },

    initializeSlider() {
      const slider = document.getElementById('system-image-slider');
      const items = slider ? slider.querySelectorAll('.slider-item') : [];

      let currentIndex = 0;
      const slideIntervalTime = 3500;

      if (!slider || items.length === 0) {
        return;
      }

      this.showSlide(items, currentIndex);

      const nextSlide = () => {
        currentIndex = (currentIndex + 1) % items.length;
        this.showSlide(items, currentIndex);
      };

      if (items.length > 1) {
        this.slideInterval = setInterval(nextSlide, slideIntervalTime);
      }
    },

    initializeFaqs() {
      document.querySelectorAll('.faq-question').forEach(btn => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.faq-item');
          if (!item) return;

          document.querySelectorAll('.faq-item.active').forEach(activeItem => {
            if (activeItem !== item) {
              activeItem.classList.remove('active');
            }
          });

          item.classList.toggle('active');
        });
      });
    },

    initializeHamburgerMenu() {
      const hamburger = document.getElementById('hamburger');
      const mobileMenu = document.getElementById('mobileMenu');

      if (hamburger && mobileMenu) {
        hamburger.addEventListener('click', () => {
          const isExpanded = mobileMenu.getAttribute('aria-hidden') === 'false';
          mobileMenu.setAttribute('aria-hidden', String(!isExpanded));
          mobileMenu.style.display = isExpanded ? 'none' : 'flex';
          hamburger.classList.toggle('is-active');
        });
      }
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#seccion-destino {
  scroll-margin-top: 60px;
}

#seccion-preguntas {
  scroll-margin-top: 60px;
}

#seccion-contactanos {
  scroll-margin-top: 60px;
}


body {
  font-family: "Poppins", sans-serif;
  background: #ffffff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}

.whatsapp-float {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  background-color: #25D366;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
  color: white;
  font-size: 35px;
}

.whatsapp-float:hover {
  transform: scale(1.1);
}

.whatsapp-float img {
  border-radius: 50%;
  display: block;
}

a {
  text-decoration: none;
  color: inherit;
}

.page-wrapper {
  width: 100%;
  min-height: 100vh;
  padding: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-header {
  color: black;
  text-align: center;
}

.section-header h1 {
  font-size: 44px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.2;
  margin-bottom: 15px;
}

.section-header h2 {
  font-size: 30px;
  margin-bottom: 20px;
  font-weight: 500;
}

.login-btn,
.select-plan-btn {
  background: #29b9f6;
  color: #fff;
  padding: 15px 30px;
  border-radius: 10px;
  border: none;
  font-weight: 700;
  cursor: pointer;
  font-size: 15px;
  text-align: center;
  display: inline-block;
  text-transform: uppercase;
  transition: background-color 0.3s, transform 0.2s;
}

.login-btn:hover {
  background: #246d8e;
}

.select-plan-btn {
  background: #29b9f6;
  color: #0c2b1a;
  border-radius: 14px;
  font-weight: 700;
  font-size: 17px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.select-plan-btn:hover {
  transform: translateY(-2px);
}

.select-plan-btn.integrated {
  background: #29b9f6;
  color: #fff;
  border-radius: 10px;
}

.select-plan-btn.integrated:hover {
  background: #246d8e;
}

.hero-content-clean {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;
  color: #fff;
}

.hero-title {
  font-size: 56px;
  font-weight: 800;
  line-height: 1.15;
  max-width: 900px;
}

.hero-subtitle {
  font-size: 22px;
  margin: 20px 0 70px;
  opacity: 0.95;
  max-width: 720px;
}

.hero-main-cta {
  background: #29b9f6;
  color: #fff;
  padding: 16px 36px;
  border-radius: 30px;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
}

.hero-proof {
  margin-top: 14px;
  font-size: 14px;
  opacity: 0.85;
}

.hero-wrapper {
  position: relative;
  width: 100%;
  height: 90vh;
  border-radius: 18px;
  overflow: hidden;
  background: #000;
}

.hero-nav {
  position: absolute;
  top: 20px;
  left: 30px;
  right: 30px;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  width: 350px;
  background: white;
  border-radius: 10px;
  padding: 8px
}

.nav-center {
  display: flex;
  gap: 22px;
  align-items: center;
  font-size: 20px;
}

.nav-center a {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  padding: 6px 10px;
  transition: color 0.3s;
}

.nav-center a:hover {
  color: #29b9f6;
}

.nav-right {
  display: flex;
  gap: 14px;
  align-items: center;
}

.hero-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.hero-wrapper::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 5;
  background: linear-gradient(to right, rgba(8, 18, 30, 0.65) 0%, rgba(8, 18, 30, 0.45) 45%, rgba(8, 18, 30, 0.65) 100%);
}

.hero-pretitle {
  position: relative;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -150%);
  display: block;
  color: #fff;
  font-size: 25px;
  font-weight: 700;
  padding: 12px 0px;
  border-radius: 50px;
  max-width: fit-content;
  text-align: center;
  z-index: 10;
  letter-spacing: 1px;
}

.big-word {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 220px;
  line-height: 0.85;
  font-weight: 900;
  letter-spacing: 18px;
  z-index: 6;
  pointer-events: none;
  user-select: none;
  background: linear-gradient(to bottom, #ffffff26, #29b9f629);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.mobile-menu {
  position: absolute;
  top: 76px;
  right: 30px;
  z-index: 22;
  width: 220px;
  background: rgba(6, 10, 14, 0.9);
  border-radius: 10px;
  display: none;
  flex-direction: column;
  padding: 12px;
}

.mobile-menu a {
  color: #fff;
  padding: 10px;
  text-decoration: none;
  border-radius: 6px;
}

.mobile-menu a:hover {
  background: rgba(255, 255, 255, 0.04);
}

.system-overview-section {
  width: 100%;
  padding: 70px 0;
  background: #ffffff;
  color: #333;
  display: flex;
  justify-content: center;
}

.system-overview-container,
.solar-benefits-container,
.faqs-container {
  width: 90%;
  max-width: 1400px;
  margin: auto;
}

.system-content-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}

.system-image-box {
  position: relative;
  background: #29b9f6;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  padding: 20px;
  text-align: center;
  max-width: 1400px;
}

.slider-item {
  display: none;
}

.slider-item.active {
  display: block;
}

.slider-item img {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 12px;
  display: block;
  margin-bottom: 15px;
}

.slider-item .module-description {
  font-size: 18px;
  color: black;
  margin-top: 0;
  padding: 0 10px;
}

.solar-benefits-section {
  width: 100%;
  padding: 80px 0;
  background: #f8f8f8;
  color: #333;
  display: flex;
  justify-content: center;
}

.benefits-subtitle {
  font-size: 20px;
  color: #555;
  margin-top: 10px;
  margin-bottom: 50px;
  font-weight: 500;
}

.cards-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(min-content, max-content);
  gap: 30px;
  text-align: center;
}

.benefit-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.benefit-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

.benefit-icon {
  font-size: 48px;
  margin-bottom: 15px;
  color: #29b9f6;
}

.benefit-card h3 {
  font-size: 22px;
  color: #0a0a0a;
  font-weight: 700;
  margin-bottom: 15px;
}

.benefit-card p {
  font-size: 15px;
  color: #555;
  line-height: 1.6;
}

.system-info-card {
  grid-column: 1 / -1;
  grid-row: 2;
  background: url(../assets/images/PanelSVG.svg) no-repeat right center;
  background-color: #2a428c;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  padding: 40px;
  display: flex;
  align-items: flex-end;
  min-height: 450px;
  transition: transform 0.3s ease;
}

.system-info-card:hover {
  transform: scale(1.01);
}

.system-info-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.1) 100%);
  z-index: 1;
}

.info-content {
  position: relative;
  z-index: 2;
  color: #fff;
  display: flex;
  gap: 40px;
  width: 100%;
  align-items: center;
}

.info-text-right {
  position: absolute;
  border: 0;
  bottom: 0;
  right: 20px;
}

.info-text-right h3 {
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 15px;
  line-height: 1.2;
}

.info-text-right .stars {
  color: #29b9f6;
  font-size: 20px;
  font-weight: 700;
}

.integrated-price-box {
  background: #ffffff;
  color: #000;
  padding: 35px;
  border-radius: 16px;
  max-width: 350px;
  flex-shrink: 0;
  text-align: left;
}

.integrated-price-box h3 {
  color: #0a0a0a;
  font-size: 24px;
  font-weight: 800;
  margin: 0;
}

.integrated-price-box .price-value {
  font-size: 48px;
  font-weight: 800;
  color: #29b9f6;
  margin-bottom: 20px;
  line-height: 1;
}

.integrated-price-box .price-value span {
  font-size: 18px;
  color: #555;
  font-weight: 500;
}

.features-list-integrated {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
  border-top: 1px dashed #eee;
  padding-top: 15px;
}

.features-list-integrated li {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
}

.faqs-section {
  padding: 0 0 300px;
  background: #f9f9f9;
}

.faqs-container {
  max-width: 1400px;
  margin: auto;
}

.faqs-wrapper {
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding-top: 40px;
  align-items: start;
}

.faq-left-card {
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  height: fit-content;
}

.faq-icon-large {
  color: #29b9f6;
  font-size: 150px;
}

.faq-item {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 15px;
  overflow: hidden;
  background-color: #fff;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px;
  background-color: #fff;
  border: none;
  text-align: left;
  font-weight: 600;
  cursor: pointer;
  font-size: 16px;
  color: #333;
}

.faq-icon {
  font-size: 24px;
  line-height: 1;
  transition: transform 0.3s ease;
}

.faq-item.active .faq-icon {
  transform: rotate(45deg);
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  padding: 0 15px;
}

.faq-answer p {
  padding-bottom: 15px;
  margin: 0;
  color: #555;
}

.faq-item.active .faq-answer {
  max-height: 500px;
}

.cta-wrapper {
  width: 100%;
  padding: 80px 0 0px;
  background: #000;
  display: flex;
  justify-content: center;
}

.cta-container {
  width: 90%;
  max-width: 1400px;
  background-color: #2a428c;
  border-radius: 20px;
  padding: 50px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  background-image: url(../assets/images/Cuadricula.png);
  margin-top: -310px;
  position: relative;
}

.cta-sub {
  color: black;
  font-size: 16px;
  margin-bottom: 10px;
}

.cta-title {
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
}

.cta-title span {
  color: black;
}

.cta-desc {
  color: #d8d8d8;
  line-height: 1.6;
  margin-bottom: 30px;
}

.cta-phone-box {
  background: #fff;
  color: #000;
  padding: 18px 22px;
  border-radius: 16px;
  display: flex;
  gap: 14px;
  align-items: center;
  max-width: 300px;
  font-size: 15px;
}

.cta-phone-box strong {
  color: #000;
}

.cta-right img {
  width: 100%;
  border-radius: 16px;
  object-fit: cover;
}

.footer {
  background: #000;
  padding: 80px 0 40px;
  color: #fff;
}

.footer-top {
  width: 90%;
  max-width: 1400px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
}

.footer-col {
  width: 45%;
}

.footer-col.contact-box {
  width: 30%;
  background: #2a428c;
  color: white;
  padding: 26px;
  border-radius: 16px;
  background-image: url(../assets/images/PanelSVG.svg);
}

.footer-logo img {
  height: 60px;
  background-color: white;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}

.footer-desc {
  color: #d2d2d2;
  margin-bottom: 20px;
  line-height: 1.6;
  text-align: justify;
}

.footer-social a {
  font-size: 1.5rem;
  color: #ffffff;
  margin: 0 5px;
  transition: color 0.3s;
}

.footer-social a:hover {
  color: #29b9f6;
}

.contact-box h3 {
  margin-bottom: 16px;
  color: white;
}

.contact-box p {
  margin-bottom: 10px;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
}

.contact-box a {
  color: white;
}

.footer-bottom {
  margin-top: 50px;
  border-top: 1px solid #222;
  padding-top: 20px;
  color: #aaa;
  display: flex;
  justify-content: space-between;
  width: 90%;
  max-width: 1400px;
  margin: 50px auto 0;
  align-items: center;
  flex-wrap: wrap;
}

.footer-links a {
  color: #aaa;
  margin: 0 8px;
}

.footer-links a:hover {
  color: #fff;
}

.powered-by {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9em;
  color: #a0a0a0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
  backdrop-filter: blur(5px);
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: modalFadeIn 0.3s ease-out;
}

.close-modal-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 32px;
  color: #888;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s;
  z-index: 10;
}

.close-modal-btn:hover {
  color: #333;
}

.modal-header {
  text-align: center;
  margin-bottom: 20px;
}

.modal-logo {
  height: 60px;
  margin-bottom: 10px;
  padding: 5px;
  border-radius: 5px;
}

.modal-header h2 {
  font-size: 24px;
  color: #0a0a0a;
  margin-bottom: 5px;
}

.modal-header p {
  color: #666;
  font-size: 14px;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 900px) {
  .modal-content {
    padding: 20px;
    max-height: 95vh;
  }

  .cta-sub {
    display: none;
  }

  .system-overview-section {
    padding: 20px 0;
  }

  .page-wrapper {
    padding: 15px;
  }

  .hero-nav {
    left: 15px;
    right: 15px;
  }

  .nav-center {
    display: none;
  }

  .logo {
    width: 150px;
  }

  .hero-pretitle {
    font-size: 15px;
    padding: 8px 20px;
    top: 85%;
    transform: translate(-50%, -100%);
  }

  .big-word {
    font-size: 60px;
    letter-spacing: 0px;
    bottom: 70px;
  }

  .section-header h1 {
    font-size: 22px;
  }

  .cta-desc {
    text-align: justify;
  }

  .section-header h2 {
    font-size: 18px;
  }

  .system-content-wrapper {
    margin-top: 30px;
  }

  .slider-item .module-description {
    font-size: 16px;
  }

  .solar-benefits-section {
    padding: 60px 0 60px;
  }

  .benefits-subtitle {
    font-size: 16px;
    margin-bottom: 30px;
  }

  .cards-wrapper {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .system-info-card {
    grid-row: 4;
    min-height: 400px;
    padding: 30px;
    background-image: none;
    background-color: #29b9f6;
    align-items: flex-start;
  }

  .info-content {
    flex-direction: column;
    gap: 0px;
    align-items: flex-start;
  }

  .integrated-price-box {
    max-width: 100%;
    padding: 25px;
  }

  .info-text-right {
    position: static;
    text-align: left;
    margin-top: 20px;
  }

  .info-text-right h3 {
    font-size: 25px;
    margin-bottom: 10px;
  }

  .info-text-right .stars {
    font-size: 16px;
  }

  .faqs-section {
    padding: 0 0 220px;
  }

  .faqs-wrapper {
    grid-template-columns: 1fr;
    padding-top: 20px;
  }

  .hero-title {
    font-size: 32px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .faq-left-card {
    display: none;
  }

  .cta-container {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 30px;
    margin-top: -280px;
    gap: 10px;
  }

  .cta-left {
    order: 2;
  }

  .cta-right {
    order: 1;
  }

  .cta-title {
    font-size: 28px;
  }

  .cta-phone-box {
    margin: 0 auto;
  }

  .footer {
    padding: 40px 0 20px;
  }

  .footer-top {
    flex-direction: column;
    gap: 30px;
  }

  .footer-col {
    width: 100%;
  }

  .footer-col.contact-box {
    display: none;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    text-align: center;
    margin: 10px auto 0;
  }

  .footer-links {
    order: 1;
  }

  .powered-by {
    order: 2;
  }
}

@media (max-width: 400px) {}
</style>